import React, { useState,useEffect } from "react";
import StadoPayrollFooter from "./StadoPayrollFooter";

export default function TermsAndConditions() {
  const [agreed, setAgreed] = useState(false);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
  document.title = "Terms & Conditions – Stado Payroll";

  const link = document.querySelector("link[rel~='icon']");
  if (link) link.href = "/payrollfavicons.png";
}, []);
  const handleAgreement = () => {
    setLoading(true);
    // Simulate a save/redirect process
    setTimeout(() => {
      setLoading(false);
      setAgreed(true);
      // Optional: window.location.href = "/dashboard"; 
    }, 1500);
  };

  return (
    <>
      <section className="relative bg-[#050505] text-gray-200 py-20 px-4 overflow-hidden font-sans">
        
        {/* Soft Brand Glow Effects */}
        <div className="pointer-events-none absolute -top-40 -right-40 w-[420px] h-[420px] rounded-full bg-[#f68c51]/20 blur-[160px]" />
        <div className="pointer-events-none absolute top-1/2 -left-40 w-[420px] h-[420px] rounded-full bg-[#fd2c55]/20 blur-[160px]" />

        <div className="relative max-w-5xl mx-auto leading-relaxed text-sm md:text-base space-y-8">
          
          {/* TITLE SECTION */}
          <div className="text-center mb-14">
            <h1 className="text-3xl md:text-4xl mt-10 font-bold text-white tracking-wide">
              Terms & Conditions
            </h1>
            <div className="mt-3 h-[2px] w-24 mx-auto rounded-full bg-gradient-to-r from-[#f68c51] to-[#fd2c55]" />
            <p className="mt-4 italic text-gray-400">Last Updated: 06.12.2025</p>
          </div>

          <p>
            Welcome to <strong>Stado Payroll</strong> (“Company”, “we”, “our”, “us”). These Terms & Conditions (“Terms”) govern your access and use of our website 
            <span className="text-[#f68c51]"> payroll.stadoworld.com</span>, mobile app, dashboard, and all related HRMS and payroll services (“Services”).
          </p>

          <p className="font-semibold text-white uppercase border-l-4 border-[#fd2c55] pl-4 bg-white/5 rounded-md py-3">
            BY ACCESSING OR USING OUR SERVICES, YOU AGREE TO BE BOUND BY THESE TERMS. IF YOU DO NOT AGREE, PLEASE DISCONTINUE USE OF OUR PLATFORM.
          </p>

          {/* SECTION 1: DEFINITIONS */}
          <h2 className="text-xl font-semibold text-white pt-8 relative inline-block">
            1. Definitions
            <span className="absolute left-0 -bottom-1 h-[2px] w-full bg-gradient-to-r from-[#f68c51] to-[#fd2c55]" />
          </h2>
          <ul className="list-disc pl-6 space-y-2 text-gray-300">
            <li><strong>Platform:</strong> Stado Payroll website, admin panel, mobile app, and related tools.</li>
            <li><strong>User / You:</strong> Employers, administrators, employees, or anyone accessing the Platform.</li>
            <li><strong>Subscription:</strong> The paid plan purchased to access premium features.</li>
          </ul>

          {/* SECTION 2: ELIGIBILITY */}
          <h2 className="text-xl font-semibold text-white pt-8 relative inline-block">
            2. Eligibility
            <span className="absolute left-0 -bottom-1 h-[2px] w-full bg-gradient-to-r from-[#f68c51] to-[#fd2c55]" />
          </h2>
          <p>To use Stado Payroll, you must be at least 18 years old, have the authority to bind your organization, and provide accurate registration information in compliance with all applicable laws.</p>

          {/* SECTION 3: ACCOUNT RESPONSIBILITIES */}
          <h2 className="text-xl font-semibold text-white pt-8 relative inline-block">
            3. Account Responsibilities
            <span className="absolute left-0 -bottom-1 h-[2px] w-full bg-gradient-to-r from-[#f68c51] to-[#fd2c55]" />
          </h2>
          <p>You are responsible for maintaining the confidentiality of your login credentials. Any actions taken under your account are deemed authorized by you. We reserve the right to suspend accounts involved in misuse.</p>

          {/* SECTION 4: PLATFORM USE */}
          <h2 className="text-xl font-semibold text-white pt-8 relative inline-block">
            4. Use of the Platform
            <span className="absolute left-0 -bottom-1 h-[2px] w-full bg-gradient-to-r from-[#f68c51] to-[#fd2c55]" />
          </h2>
          <p>You agree to use Stado Payroll only for lawful HRMS activities. You must not reverse-engineer the platform, upload harmful scripts, or attempt unauthorized access to our servers or source code.</p>

          {/* SECTION 5: DATA OWNERSHIP */}
          <h2 className="text-xl font-semibold text-white pt-8 relative inline-block">
            5. Data Ownership & User Content
            <span className="absolute left-0 -bottom-1 h-[2px] w-full bg-gradient-to-r from-[#f68c51] to-[#fd2c55]" />
          </h2>
          <p>All employee records, attendance logs, and payroll data uploaded by you remain your property. You grant us a limited license to process this data solely for providing Services like generating payroll and running analytics.</p>

          {/* SECTION 6: PAYMENTS */}
          <h2 className="text-xl font-semibold text-white pt-8 relative inline-block">
            6. Subscription, Payments & Refunds
            <span className="absolute left-0 -bottom-1 h-[2px] w-full bg-gradient-to-r from-[#f68c51] to-[#fd2c55]" />
          </h2>
          <p>Payments are collected via secure gateways (e.g., Razorpay). Subscription fees are non-refundable unless required by law. Failed renewals may result in feature restrictions or temporary suspension.</p>

          {/* SECTION 7: WALLET POLICY */}
          <h2 className="text-xl font-semibold text-white pt-8 relative inline-block">
            7. Wallet & Recharge Policy
            <span className="absolute left-0 -bottom-1 h-[2px] w-full bg-gradient-to-r from-[#f68c51] to-[#fd2c55]" />
          </h2>
          <p>Wallet balances are non-transferable and cannot be withdrawn as cash. Funds are applied strictly to assigned modules, campaigns, or services within the Stado ecosystem.</p>

          {/* SECTION 8: INTELLECTUAL PROPERTY */}
          <h2 className="text-xl font-semibold text-white pt-8 relative inline-block">
            8. Intellectual Property
            <span className="absolute left-0 -bottom-1 h-[2px] w-full bg-gradient-to-r from-[#f68c51] to-[#fd2c55]" />
          </h2>
          <p>All software, source code, UI/UX, logos, and HRMS architecture belong to <strong>Stado Payroll</strong>. Copying, replicating, or reselling any part of the platform is strictly prohibited.</p>

          {/* SECTION 9: GOVERNING LAW */}
          <h2 className="text-xl font-semibold text-white pt-8 relative inline-block">
            9. Governing Law & Contact
            <span className="absolute left-0 -bottom-1 h-[2px] w-full bg-gradient-to-r from-[#f68c51] to-[#fd2c55]" />
          </h2>
          <p>These Terms are governed by the laws of India. Any disputes shall fall under the exclusive jurisdiction of courts located in <strong>Patna, Bihar</strong>.</p>

          <div className="bg-white/5 p-4 rounded-md border border-gray-800 space-y-2">
            <p><strong>Stado Payroll</strong></p>
            <p><strong>Email:</strong> <a href="mailto:support@stadopayroll.com" className="text-[#f68c51] hover:underline">support@stadopayroll.com</a></p>
          </div>

          {/* AGREE BUTTON LOGIC */}
          <div className="flex flex-col items-center justify-center pt-14 space-y-4">
            <button 
              onClick={handleAgreement}
              disabled={loading || agreed}
              className={`
                relative overflow-hidden
                px-10 py-3
                rounded-full
                font-semibold
                text-white
                shadow-lg
                transition-all duration-300
                ${agreed 
                  ? "bg-green-600 shadow-[0_0_20px_rgba(22,163,74,0.4)]" 
                  : "bg-gradient-to-r from-[#f68c51] to-[#fd2c55] hover:scale-105 hover:shadow-[0_0_30px_rgba(253,44,85,0.45)]"
                }
                ${loading ? "opacity-70 cursor-not-allowed" : ""}
              `}
            >
              {loading ? "Processing..." : agreed ? "✓ AGREED" : "I ACCEPT THESE TERMS"}
            </button>
            {agreed && <p className="text-green-400 text-sm animate-pulse">Thank you! Your agreement has been recorded.</p>}
          </div>

          

        </div>
      </section>
      <StadoPayrollFooter/>
    </>
  );
}